import { c as _c } from "react/compiler-runtime";
import { EnhancedJsonView } from "@/components/ui/enhanced-json-view";
import type { RenderContext } from "./types";

/** Shared raw-JSON-tree fallback markup, used by both FallbackRenderer and
 *  ValueErrorBoundary so the styling stays in one place. */
export function JsonFallback(t0) {
  const $ = _c(3);
  const {
    value,
    ctx
  } = t0;
  let t1;
  if ($[0] !== ctx.key || $[1] !== value) {
    t1 = <span className="font-mono text-xs"><EnhancedJsonView value={value} keyName={ctx.key} defaultExpanded={true} expandAll={false} /></span>;
    $[0] = ctx.key;
    $[1] = value;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}